import "./addNote.scss";
import {useState} from "react";
import { toast } from "react-toastify";
import { AddNote } from "../../services/noteBookService";
import Button from "../button/button";
import IconButton from "../iconButton/iconButton"
import AddNoteIcon from "../../assets/images/notePassive.svg";
import EnterIcon from "../../assets/images/enter.svg";
import CloseIcon from "../../assets/images/closeCancel.svg";

export default function AddNoteBook({date, afterAddNote, onClose}) {
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
 
  function handleAddNote(e) {
    setNote(e.target.value);
  }

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      e.preventDefault();
      onClose();
    }
    if (e.key === "Enter" && e.ctrlKey) {
      e.preventDefault();
      addNote();
    }
  }

  const addNote =  async () => {
    if (note !== "") {
      try {
        setLoading(true);
        await AddNote(note, date);
        setLoading(false);
        setNote("");
        afterAddNote();
      } catch (err) {
        setLoading(false);
        toast.error(err.error, { toastId: "error" });
      }
    }
  }

  return (
    <div className="addNote actionWrapper">
      <IconButton icon={CloseIcon} tooltip="بیخیال" onClick={onClose} className="closeIcon" />
      <img src={AddNoteIcon} alt="icon" className="notMobile" />
      <textarea onChange={ (e) => handleAddNote(e)} value={note} rows={2} placeholder="یادداشتت رو اینجا بنویس و ثبت کن" onKeyDown ={e=>handleKeyDown(e)}  autoFocus></textarea>
      <Button text="ثبت"  onClick={() => addNote()} className="center notDesktop" width={100} />
      <IconButton icon={EnterIcon} loading={loading} tooltip="ثبت یادداشت" onClick={ () => addNote()} className="notMobile" />
    </div>
  );
}
